import { combine, createEffect, createEvent, createStore } from 'effector';
import { axiosClient } from '@nx-frontend/shared/api';
import { $orgRoleState } from '@nx-frontend/shared/store/org-role';
import { OrganizationPrivilege, OrgMemberRole, WorkspaceRole } from '@nx-frontend/shared/types';
import { WorkspaceAccess } from '@nx-frontend/shared/types';
import { WorkspacePrivilege } from '@nx-frontend/shared/types';

export const initialWorkspaceAccessState: WorkspaceAccess = {
  type: OrgMemberRole.GUEST,
  role: WorkspaceRole.DENIED,
  encryptRole: null,
  privileges: null,
  reduced: true,
  orgId: '',
};

// init units
const updateWorkspaceAccessFx = createEffect(async ({ workspaceId }: { workspaceId: string }) => {
  const workspaceAccess = await axiosClient.get<WorkspaceAccess>(`/v2/api/workspaces/${workspaceId}/access`);
  return workspaceAccess.data;
});
export const updateWorkspaceAccessEvent = createEvent<{ workspaceId: string }>();
export const $workspaceAccess = createStore(initialWorkspaceAccessState);

// subscribe
updateWorkspaceAccessEvent.watch(({ workspaceId }) => {
  updateWorkspaceAccessFx({ workspaceId });
});
$workspaceAccess.on(updateWorkspaceAccessFx.doneData, (state, data) => (data ? data : state));

// export mapped stores
export const $wpCanManageMembers = combine($workspaceAccess, $orgRoleState, (store, role) => {
  // if user has canManageMembers privilege in workspace or canAddMembers in organization then
  // they can manage workspace members
  return (
    store.privileges?.includes(WorkspacePrivilege.CAN_MANAGE_MEMBERS) ||
    role.privileges.includes(OrganizationPrivilege.CAN_ADD_MEMBERS)
  );
});

export const $wpCanManagePermissions = combine($orgRoleState, (role) => {
  return role.privileges.includes(OrganizationPrivilege.CAN_MANAGE_PERMISSIONS);
});

// FIXME: remove this store after calculating correct privileges on backend
// here we are checking if the user can invite members ro workspace, if he can, then he can also access org panel
export const $opCanAccessOrgPanel = combine($orgRoleState, $workspaceAccess, (role, workspaceAccess) => {
  if (
    !role.privileges.includes(OrganizationPrivilege.CAN_ACCESS_ORG_PANEL) &&
    workspaceAccess.privileges?.includes(WorkspacePrivilege.CAN_MANAGE_MEMBERS)
  ) {
    return true;
  }
  return role.privileges.includes(OrganizationPrivilege.CAN_ACCESS_ORG_PANEL);
});
